var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17.607,
  height: 17.607,
  x: 3.197,
  y: 4.769,
  stroke: "#232323",
  strokeWidth: 1.25,
  rx: 5.661
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#232323",
  strokeWidth: 1.571,
  d: "M12.001 4.144V1.001"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#232323",
  strokeLinecap: "round",
  strokeWidth: 2.357,
  d: "M7.679 12.393v-1.572M16.321 12.393v-1.572"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#232323",
  strokeLinecap: "round",
  strokeWidth: 1.571,
  d: "M9.643 16.715c.14.05 2.362 1.742 4.714 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#232323",
  strokeWidth: 1.571,
  d: "M21.43 12.786h2.357M.215 12.786h2.357"
})));
export default SvgAi;